jQuery(function($) {
  const rootClass = 'acf-timeline'
  const yearElement = 'year'
  const eventsElement = 'event'
  const buttonElement = 'arrow'

  const animationSpeed = $(`.${rootClass}`)
    .find('#animation_speed').val()

  $(`.${rootClass}__${yearElement}`).css('transition', `all ${animationSpeed}ms`)

  function isLastYear() {
    return $(`.${rootClass}__year`)
      .last()
      .hasClass(`${rootClass}__${yearElement}--selected`)
  }

  function isFirstYear() {
    return $(`.${rootClass}__year`)
      .first()
      .hasClass(`${rootClass}__${yearElement}--selected`)
  }

  function moveClassToNext(element, modifier) {
    const fullClass = `${rootClass}__${element}--${modifier}`

    $(`.${fullClass}`)
      .removeClass(fullClass)
      .next()
      .addClass(fullClass)
  }

  function moveClassToPrev(element, modifier) {
    const fullClass = `${rootClass}__${element}--${modifier}`

    $(`.${fullClass}`)
      .removeClass(fullClass)
      .prev()
      .addClass(fullClass)
  }

  function nextEventYear() {
    $(`.${rootClass}__${yearElement}--first`)
      .addClass(`${rootClass}__${yearElement}--past`)

    moveClassToNext(yearElement, 'first')

    if (isFirstYear()) {
      $(`.${rootClass}__${yearElement}`)
        .first()
        .addClass(`${rootClass}__${yearElement}--first`)
    }

    moveClassToNext(yearElement, 'selected')
  }

  function prevEventYear() {
    moveClassToPrev(yearElement, 'first')
    moveClassToPrev(yearElement, 'selected')

    $(`.${rootClass}__${yearElement}--first`)
      .removeClass(`${rootClass}__${yearElement}--past`)
  }

  function nextEventBody() {
    const fullEl = `${rootClass}__${eventsElement}`

    $(`.${fullEl}--after`)
      .first()
      .removeClass(`${fullEl}--after`)

    $(`.${fullEl}--selected`)
      .addClass(`${fullEl}--before`)

    moveClassToNext(eventsElement, 'selected')
  }

  function prevEventBody() {
    const fullEl = `${rootClass}__${eventsElement}`

    $(`.${fullEl}--before`)
      .last()
      .removeClass(`${fullEl}--before`)

    $(`.${fullEl}--selected`)
      .addClass(`${fullEl}--after`)

    moveClassToPrev(eventsElement, 'selected')
  }

  function moveToYear(year) {
    const currentYear = $(`.${rootClass}__${yearElement}--selected`)
    const yearIsInFuture = year.isAfter(currentYear)

    let atCorrectYear = false

    while (!atCorrectYear) {
      if (yearIsInFuture) {
        next()
      } else {
        prev()
      }

      atCorrectYear = currentYear.eq(year)
    }
  }

  function next() {
    if (!isLastYear()) {
      nextEventYear()
      nextEventBody()
    }
  }

  function prev() {
    if (!isFirstYear()) {
      prevEventYear()
      prevEventBody()
    }
  }

  const initialLeftScroll = 1
  const scrollThreshold = 4
  let scrollAmount = 0
  let isActive = true

  setInterval(() =>{
    scrollAmount = 0
  } , 200)

  $(`.${rootClass}`)
    .scrollLeft(initialLeftScroll)
    .scroll(function(evt) {
      const newScroll = $(this).scrollLeft()
      $(this).scrollLeft(initialLeftScroll)
      const leftScroll = newScroll > initialLeftScroll
      const rightScroll = newScroll < initialLeftScroll

      leftScroll && scrollAmount++
      rightScroll && scrollAmount++

      if (leftScroll && isActive && scrollAmount > scrollThreshold) {
        scrollAmount++
        isActive = false
        setTimeout(() => isActive = true, parseInt(animationSpeed * 4))
        next()
      }

      if (rightScroll && isActive && scrollAmount > scrollThreshold) {
        scrollAmount++
        setTimeout(() => isActive = true, parseInt(animationSpeed * 4))
        isActive = false
        prev()
      }
    })
    .swipeDetector()
    .on('swipeLeft.sd swipeRight.sd', function(evt) {
      if ($(window).width() <= 768) {
        if (evt.type === 'swipeLeft') {
          next()
        }

        if (evt.type === 'swipeRight') {
          prev()
        }
      }
    })

  $(`.${rootClass}__${buttonElement}--left`).on('click', function() {
    prev()
  })

  $(`.${rootClass}__${buttonElement}--right`).on('click', function() {
    next()
  })

  $(`.${rootClass}__${yearElement}`).on('click', function() {
    if ($(this).attr('class').indexOf(`${rootClass}__${yearElement}--selected`) < 0)
      moveToYear($(this))
  })
})



// WEBPACK FOOTER //
// ./scripts/acf-blocks/timeline.js